import { Box } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { CartIcon } from '@/assets/svg';
import { AddProductsModal } from '@/components';
import { useDBSyncContext } from '@/context/DBSyncContext';
import { COLOR } from '@/theme/colors';

import { Props } from './types';

function AddShoppingListProductModal({ onCancel, onMainAction }: Props) {
    const { t } = useTranslation();
    const { isSyncInProgress } = useDBSyncContext();

    return (
        <AddProductsModal
            icon={
                <Box
                    sx={{
                        width: 40,
                        height: 36,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <CartIcon color={COLOR.deepCerulean} />
                </Box>
            }
            mainActionButtonCaption={t('Inventory:button:add_to_shopping_list')}
            onMainAction={onMainAction}
            onCancel={onCancel}
            title={t('Inventory:modal:add_products_title')}
            showOftenUsedFilter
            showInventoryFilter
            showUnitTypes
            disableMainActionButton={isSyncInProgress}
        />
    );
}

export default AddShoppingListProductModal;
